export const GET_PLATFORM_SETTINGS = "GET_PLATFORM_SETTINGS"
export const GET_PLATFORM_SETTINGS_SUCCESS = "GET_PLATFORM_SETTINGS_SUCCESS"
export const GET_PLATFORM_SETTINGS_ERROR = "GET_PLATFORM_SETTINGS_ERROR"